import React, { useEffect, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { Col, Form, Row } from "react-bootstrap";
import {
  checkEmptySpaces,
  EmailValidation,
  maxLength,
  Required,
} from "../../../../utils/patterns";
import TextInput from "../../../../components/common/input-field/TextInput";
import ThemeButton from "../../../../components/common/theme-button/ThemeButton";
import PhoneField from "../../../../components/common/phone-field/PhoneField";
// import VenueLocationOtp from "../../account-setup/venue-location/VenueLocationOtp";
import { message, notification, Spin, Upload } from "antd";
import {
  CameraIcon,
  CloseRoundedCheck,
  RoundedCheck,
} from "../../../../../assets/icons/defaultIcons";
import { UserAuthService } from "../../../../services/user-auth-api.service";
import { S3Service } from "../../../../services/s3-api.service";
import { useUser } from "../../../../providers/UserContext";
import EditProfileSkeleton from "../../../skeletons/my-profile/edit-pages/EditProfileSkeleton";
import { parsePhoneNumberFromString } from "libphonenumber-js";

export default function EditProfile(options) {
  const { user } = useUser();
  const [loader, setLoader] = useState(true);
  const [profileData, setProfileData] = useState([]);

  const [imageUrl, setImageUrl] = useState();
  const [file, setFile] = useState();
  const [loading, setLoading] = useState();
  const [imageChange, setImageChange] = useState(false);
  const { setProfileUpdate, profileUpdate } = useUser();
  const [image, setImage] = useState("");

  const phoneValidation = (value) => {
    if (!value) return "Phone number is required";
    const phoneNumber = parsePhoneNumberFromString(value);
    if (!phoneNumber) return "Invalid phone number";
    return phoneNumber.isValid() ? true : "Invalid phone number";
  };

  async function GetProfileData() {
    setLoader(true);
    const response = await UserAuthService.getProfileData();

    if (response?.data?.data?.status) {
      const userData = response.data.data.data.user;
      setProfileData(userData);
      const payload = {
        f_name: userData.fullName,
        phone: userData.phone,
        email: userData.email,
      };
      setLoader(false);
      reset(payload);
      setImage(response.data?.data?.data?.user?.profileImage);
    }
  }

  useEffect(() => {
    setImage(profileData.profileImage);
  }, []);

  useEffect(() => {
    GetProfileData();
  }, []);

  const {
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
    control,
    clearErrors,
    watch,
  } = useForm({
    mode: "onChange",
  });

  function imageUpload() {}

  const password = useRef({});
  password.current = watch("password", "");
  const gender = [
    {
      value: 1,
      label: "Male",
    },
    {
      value: 2,
      label: "Female",
    },
    {
      value: 3,
      label: "Other",
    },
  ];

  // Profile upload

  const getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener("load", () => callback(reader.result));
    reader.readAsDataURL(img);
  };
  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
      message.error("You can only upload JPG/PNG file!");
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error("Image must smaller than 2MB!");
    }
    return isJpgOrPng && isLt2M;
  };

  const handleImageChange = async (event) => {
    const file = event.file;
    setLoading(true);
    if (file.type !== "image/jpeg" && file.type !== "image/png") {
      message.error("You can only upload JPG/PNG files!");
      setLoading(false); // Stop loading
      return;
    }
    if (file.size / 1024 / 1024 >= 2) {
      message.error("Image must be smaller than 2MB!");
      setLoading(false); // Stop loading
      return;
    }

    const reader = new FileReader();
    reader.onload = function () {
      const output = reader.result;
      setImage(output);
      setFile(file);
      // console.log(file, 'file')
      // console.log(image, 'image')
    };
    setLoading(false);
    reader.readAsDataURL(file);
  };
  const uploadButton = (
    <div>
      {loading ? (
        <Spin />
      ) : (
        <div>
          <CameraIcon />
        </div>
      )}
    </div>
  );

  const onSubmit = async (data) => {
    setLoader(true);

    let s3UploadedFileUrl;

    if (file) {
      s3UploadedFileUrl = await S3Service.uploadToS3(
        file.type,
        file.name,
        file
      );
    }

    if (data) {
      let payload = {
        fullName: data.f_name,
        phone: data.phone,
        profileImage: s3UploadedFileUrl
          ? s3UploadedFileUrl
          : profileData?.profileImage,
      };

      const response = await UserAuthService.updateProfileData(payload);

      if (response?.data?.data?.status) {
        notification.success({
          message: "Success",
          description: response?.data?.message,
          placement: "topRight",
          icon: <RoundedCheck />,
          duration: 2,
        });
        options.close(false);
        setLoader(false);
        setProfileUpdate(!profileUpdate);
      } else {
        notification.error({
          message: "Failed",
          description: response?.data?.message,
          placement: "topRight",
          icon: <CloseRoundedCheck />,
          duration: 2,
        });
      }
    }
  };

  if (loader) {
    return <EditProfileSkeleton />;
  }

  return (
    <div className={"signup"}>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Row>
          <Col md={12}>
            <div className={"form-avatar"}>
              <div className={"dfields"}>
                <Upload
                  name="avatar"
                  listType="picture-circle"
                  className="avatar-uploader"
                  showUploadList={false}
                  accept="image/*"
                  onChange={handleImageChange}
                  beforeUpload={() => {
                    /* update state here */
                    return false;
                  }}
                >
                  {image ? (
                    <img
                      src={image}
                      alt="avatar"
                      style={{
                        width: "90px",
                        height: "90px",
                        objectFit: "cover",
                        borderRadius: "50%",
                      }}
                    />
                  ) : (
                    uploadButton
                  )}
                </Upload>
              </div>
            </div>
          </Col>
          <Col md={12}>
            <div className={"dfields"}>
              <Controller
                name="f_name"
                defaultValue={"Evan"}
                control={control}
                rules={{
                  required: Required,
                  maxLength: maxLength(100),
                  validate: checkEmptySpaces,
                }}
                render={({ field: { name, ...field } }) => (
                  <TextInput
                    placeholder={"Name"}
                    label={"Full Name"}
                    type={"text"}
                    field={field}
                    errors={errors.f_name}
                    className={"required"}
                  />
                )}
              />
            </div>
          </Col>
        </Row>
        <div className={"dfields"}>
          <Controller
            name="email"
            defaultValue={"Evanyates432@outlook.com"}
            control={control}
            rules={{
              required: Required,
              pattern: EmailValidation,
              maxLength: maxLength(100),
            }}
            render={({ field: { name, ...field } }) => (
              <TextInput
                placeholder={"Your email here"}
                label={"Email Address"}
                type={"email"}
                field={field}
                errors={errors.email}
                className={"required"}
                disabled={true}
              />
            )}
          />
        </div>
        <div className={"dfields"}>
          <Controller
            name="phone"
            defaultValue={"+971 1231234123"}
            control={control}
            // rules={{required: Required, pattern:PhoneValidation, maxLength: maxLength(100)}}
            rules={{ validate: phoneValidation }}
            render={({ field: { name, ...field } }) => (
              <PhoneField
                label={"Phone"}
                className={"required"}
                field={field}
                errors={errors.phone}
              />
            )}
          />
        </div>

        <div className={"dfields"} style={{ marginTop: 38 }}>
          <ThemeButton
            text={"Save"}
            className={"btn-light-lg"}
            type={"submit"}
            loader={loader}
          />
        </div>
      </Form>
    </div>
  );
}
